var alertNotifications = {
	alert: {
		limitAbove: "Bovengrens overschreden",
		limitBelow: "Ondergrens overschreden"
	},
	closeBtn: "Sluiten",
	openHistory: "Waarschuwingsgeschiedenis openen"
};
var nl = {
	alertNotifications: alertNotifications
};

export { alertNotifications, nl as default };
